'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
Entry.Block = /*#__PURE__*/function () {
  function Block(block, thread) {
    (0, _classCallCheck2["default"])(this, Block);
    (0, _defineProperty2["default"])(this, "schema", {
      id: null,
      x: 0,
      y: 0,
      type: null,
      params: [],
      statements: [],
      view: null,
      thread: null,
      movable: null,
      deletable: Entry.Block.DELETABLE_TRUE,
      emphasized: false,
      readOnly: null,
      copyable: true,
      assemble: true,
      events: {},
      extensions: []
    });
    (0, _defineProperty2["default"])(this, "doSeparate", this.separate);
    var that = this;
    Entry.Model(this, false);
    this._schema = null;
    this.defaultType = block.defaultType;
    if (block._backupParams) {
      this._backupParams = block._backupParams;
    }
    this.setThread(thread);
    this.load(block);
    var category = block.category;
    if (category) {
      this.category = category;
      var entryBlock = Entry.block[this.type];
      if (entryBlock) {
        entryBlock.isFor = ["category_".concat(category)];
      }
    }
    var code = this.getCode();
    if (block.display !== undefined) {
      this.display = block.display;
    }
    code.registerBlock(this);
    if (code.object) {
      (this.events.dataAdd || []).forEach(function (fn) {
        if (_.isFunction(fn)) {
          fn(that);
        }
      });
    }
    var board = code.board;
    if (Entry.getMainWS() && Entry.isTextMode && (!board || board && board.constructor !== Entry.BlockMenu)) {
      (this.events.viewAdd || []).forEach(function (fn) {
        if (_.isFunction(fn)) {
          fn.apply(that, [that]);
        }
      });
    }
    if (block.comment) {
      this._comment = block.comment;
    }
  }
  return (0, _createClass2["default"])(Block, [{
    key: "comment",
    get: function get() {
      return this._comment;
    }
  }, {
    key: "load",
    value: function load(block) {
      if (!block.id) {
        block.id = Entry.Utils.generateId();
      }
      this.set(block);
      this.loadSchema();
    }
  }, {
    key: "changeSchema",
    value: function changeSchema(diff, changeData) {
      var params = [];
      if (changeData) {
        if (changeData.isRestore) {
          params = this._backupParams || [];
          delete this._backupParams;
        } else {
          switch (changeData.type) {
            case 'noChange':
              params = this.params;
              break;
            case 'cut':
              {
                var pos = changeData.pos;
                this.params.splice(pos);
                params = this.params;
                break;
              }
            case 'insert':
              {
                var startPos = changeData.startPos;
                var endPos = changeData.endPos;
                var schemaParams = Entry.block[this.type].params;
                params = new Array(schemaParams.length);
                for (var i = 0; i < startPos; i++) {
                  params[i] = this.params[i];
                }
                var adjust = endPos - startPos + 1;
                for (var _i = endPos + 1; _i < schemaParams.length; _i++) {
                  params[_i] = this.params[_i - adjust];
                }
                break;
              }
          }
        }
      }
      params.forEach(function (p) {
        if (p instanceof Entry.Block) {
          p.destroyView();
        }
      });
      this.set({
        params: params
      });
      this.loadSchema();
      this.view && this.view.changeType();
    }
  }, {
    key: "getSchema",
    value: function getSchema() {
      // for lazy loading
      if (!this._schema) {
        this.loadSchema();
      }
      return this._schema;
    }
  }, {
    key: "loadSchema",
    value: function loadSchema() {
      var that = this;
      this._schema = Entry.block[this.type];
      if (!this._schema) {
        return;
      }
      var _this$_schema = this._schema,
        changeEvent = _this$_schema.changeEvent,
        paramsBackupEvent = _this$_schema.paramsBackupEvent,
        destroyParamsBackupEvent = _this$_schema.destroyParamsBackupEvent;
      if (!this._schemaChangeEvent && changeEvent) {
        this._schemaChangeEvent = changeEvent.attach(this, this.changeSchema);
      }
      if (!this._paramsBackupEvent && paramsBackupEvent) {
        this._paramsBackupEvent = paramsBackupEvent.attach(this, this.paramsBackup);
      }
      if (!this._destroyParamsBackupEvent && destroyParamsBackupEvent) {
        this._destroyParamsBackupEvent = destroyParamsBackupEvent.attach(this, this.destroyParamsBackup);
      }
      var events = this._schema.events;
      if (events) {
        for (var key in events) {
          if (!this.events[key]) {
            this.events[key] = [];
          }
          var funcs = events[key];
          for (var i = 0; i < funcs.length; i++) {
            var func = funcs[i];
            if (!func) {
              continue;
            }
            if (this.events[key].indexOf(func) < 0) {
              this.events[key].push(func);
            }
          }
        }
      }
      if (this._schema.event) {
        this.thread.registerEvent(this, this._schema.event);
      }
      var thisParams = this.params;
      var params = this._schema.params;
      for (var _i2 = 0; params && _i2 < params.length; _i2++) {
        var value = thisParams[_i2] === undefined || thisParams[_i2] === null ? params[_i2].value : thisParams[_i2];
        var paramInjected = thisParams[_i2] || _i2 < thisParams.length;
        if (value && (params[_i2].type === 'Output' || params[_i2].type === 'Block')) {
          if ((0, _typeof2["default"])(value) !== 'object') {
            value = {
              type: 'number',
              params: [value]
            };
          }
          value = new Entry.Block(value, this.thread);
        }
        if (paramInjected) {
          thisParams.splice(_i2, 1, value);
        } else {
          thisParams.push(value);
        }
      }
      var statements = this._schema.statements || [];
      for (var _i3 = 0; _i3 < statements.length; _i3++) {
        if (!(this.statements[_i3] instanceof Entry.Thread)) {
          this.statements.splice(_i3, 1, new Entry.Thread(this.statements[_i3], that.getCode(), this));
        }
      }
      return true;
    }
  }, {
    key: "changeType",
    value: function changeType(type) {
      var _destroyFunc = _.partial(_.result, _, 'destroy');
      _destroyFunc(this._schemaChangeEvent);
      _destroyFunc(this._backupEvent);
      _destroyFunc(this._destroyBackupEvent);
      this.set({
        type: type
      });
      this.loadSchema();
      if (this.view) {
        this.view.changeType(type);
      }
    }
  }, {
    key: "setThread",
    value: function setThread(thread) {
      this.set({
        thread: thread
      });
    }
  }, {
    key: "getThread",
    value: function getThread() {
      return this.thread;
    }
  }, {
    key: "getStatements",
    value: function getStatements() {
      return this.statements[0];
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(blocks) {
      this.thread.insertByBlock(this, blocks);
    }
  }, {
    key: "_updatePos",
    value: function _updatePos() {
      if (!this.view) {
        return;
      }
      this.set({
        x: this.view.x,
        y: this.view.y
      });
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      if (this.view) {
        this.view.moveTo(x, y);
      }
      this._updatePos();
      this.getCode().changeEvent.notify();
    }
  }, {
    key: "createView",
    value: function createView(board, mode) {
      board = board || this.getCode().view.board;
      if (!this.view) {
        this.set({
          view: new Entry.BlockView(this, board, mode)
        });
        this._updatePos();
      }
      if (this.comment) {
        var comment = this.comment;
        if (comment instanceof Entry.Comment) {
          if (!comment.svgGroup) {
            comment.createComment(board, comment.toJSON());
          }
        } else {
          this.connectComment(new Entry.Comment(comment, board, this));
        }
      }
    }
  }, {
    key: "destroyView",
    value: function destroyView() {
      _.result(this.view, 'destroy');
      this.comment && this.comment.destroyView();
    }
  }, {
    key: "clone",
    value: function clone(thread) {
      return new Entry.Block(this.toJSON(true), thread);
    }
  }, {
    key: "toJSON",
    value: function toJSON(isNew) {
      var excludeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var jsonBlackList = ['view', 'thread', 'events'];
      var json = this._toJSON();
      var view = this.view;
      if (isNew) {
        jsonBlackList.push('id');
      }
      json.params = json.params.map(function (p, i) {
        if (p instanceof Entry.Block) {
          return p.toJSON(isNew, excludeData, option);
        } else if (option.captureDynamic && view.getParam(i) instanceof Entry.FieldDropdownDynamic) {
          return view.getParam(i).getTextValue();
        } else {
          return p;
        }
      });
      var params = [isNew, undefined, excludeData, option];
      json.statements = json.statements.map(function (s) {
        return s.toJSON.apply(s, params);
      });
      if (this._backupParams) {
        json._backupParams = this._backupParams.map(function (p) {
          if (p instanceof Entry.Block) {
            return p.toJSON();
          } else {
            return p;
          }
        });
      }
      if (this._comment) {
        var comment = this._comment;
        if (this._comment instanceof Entry.Comment) {
          comment = this._comment.toJSON();
          delete comment.id;
        }
        json.comment = comment;
      }
      return (0, _extends2["default"])(_.omit(json, [].concat(jsonBlackList, (0, _toConsumableArray2["default"])(excludeData))), _.pick(this, ['x', 'y', 'movable', 'deletable', 'emphasized', 'readOnly']));
    }
  }, {
    key: "destroy",
    value: function destroy(animate, next, isNotForce) {
      if (isNotForce && !this.isDeletable()) {
        return;
      }
      this.comment && this.comment.destroy && this.comment.destroy();
      var blockType = this.getBlockType();
      if (blockType === 'output' && !next) {
        var prevOutput = this.getPrevOutputBlock();
        var nextOutput = this.getOutputBlock();
        if (prevOutput) {
          this.separate(1);
          if (nextOutput) {
            nextOutput.separate();
            nextOutput.doInsert(prevOutput.view._contents[1]);
          }
        } else if (nextOutput) {
          _.result(nextOutput.view, '_toGlobalCoordinate');
          nextOutput.doInsert(this.getThread());
        }
      }
      var that = this;
      var params = this.params || [];
      for (var i = 0; i < params.length; i++) {
        var param = params[i];
        if (param instanceof Entry.Block) {
          param.doNotSplice = !(param.thread instanceof Entry.FieldOutput);
          param.destroy(animate);
        }
      }
      var statements = this.statements || [];
      for (var _i4 = 0; _i4 < statements.length; _i4++) {
        statements[_i4].destroy(animate);
      }
      var code = this.getCode();
      code.unregisterBlock(this);
      var thread = this.getThread();
      if (this._schema && this._schema.event) {
        thread.unregisterEvent(this, this._schema.event);
      }
      if (blockType === 'basic') {
        var prevBlock = this.getPrevBlock();
        var nextBlock = this.getNextBlock();
        if (nextBlock) {
          if (next) {
            nextBlock.destroy(animate, next);
          } else {
            var nextBlockView = nextBlock.view;
            if (!prevBlock) {
              if (thread.view) {
                var parent = thread.view.getParent();
                var pConstructor = parent.constructor;
                if (pConstructor === Entry.FieldStatement) {
                  nextBlockView && nextBlockView.bindPrev(parent);
                  parent.insertTopBlock(nextBlock);
                } else if (pConstructor === Entry.FieldStatement) {
                  nextBlock.replace(parent._valueBlock);
                } else {
                  nextBlockView && nextBlockView._toGlobalCoordinate();
                }
              }
            } else {
              nextBlockView && nextBlockView.bindPrev(prevBlock, true);
            }
          }
        }
      }
      var notSpliced = this.doNotSplice;
      if (!this.doNotSplice && thread.spliceBlock) {
        thread.spliceBlock(this);
      } else {
        delete this.doNotSplice;
      }
      this.view && this.view.destroy(animate);
      var _destroyFunc = _.partial(_.result, _, 'destroy');
      _destroyFunc(this._schemaChangeEvent);
      _destroyFunc(this._paramsBackupEvent);
      _destroyFunc(this._destroyParamsBackupEvent);
      var events = [];
      if (code.object) {
        events = events.concat(this.events.dataDestroy || []);
      }
      var board = this.getCode().board;
      if (Entry.getMainWS() && Entry.isTextMode && (!board || board && board.constructor !== Entry.BlockMenu)) {
        events = events.concat(this.events.viewDestroy || []);
      }
      events.forEach(function (fn) {
        if (_.isFunction(fn)) {
          fn.apply(that, [that, notSpliced]);
        }
      });
    }
  }, {
    key: "getView",
    value: function getView() {
      return this.view;
    }
  }, {
    key: "setMovable",
    value: function setMovable(movable) {
      if (this.movable == movable) {
        return;
      }
      this.set({
        movable: movable
      });
    }
  }, {
    key: "setCopyable",
    value: function setCopyable(copyable) {
      if (this.copyable == copyable) {
        return;
      }
      this.set({
        copyable: copyable
      });
    }
  }, {
    key: "isMovable",
    value: function isMovable() {
      return this.movable;
    }
  }, {
    key: "isCopyable",
    value: function isCopyable() {
      return this.copyable;
    }
  }, {
    key: "setDeletable",
    value: function setDeletable(deletable) {
      if (this.deletable == deletable) {
        return;
      }
      this.set({
        deletable: deletable
      });
    }
  }, {
    key: "isDeletable",
    value: function isDeletable() {
      var deletable = this.deletable;
      return deletable === Entry.Block.DELETABLE_TRUE || deletable === true;
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return this.readOnly;
    }
  }, {
    key: "isCommentable",
    value: function isCommentable() {
      var exclusion = ['basic_string_field', 'basic_boolean_field', 'basic_param'];
      var skeleton = this._schema && this._schema.skeleton;
      return !exclusion.includes(skeleton);
    }
  }, {
    key: "hasComment",
    value: function hasComment() {
      return '_comment' in this;
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return this.thread.getCode();
    }

    // command func
  }, {
    key: "doAdd",
    value: function doAdd() {
      this.getCode().changeEvent.notify();
    }
  }, {
    key: "doMove",
    value: function doMove() {
      this._updatePos();
      this.getCode().changeEvent.notify();
    }
  }, {
    key: "doInsert",
    value: function doInsert(targetBlock) {
      if (this.getBlockType() === 'basic') {
        this.insert(targetBlock);
      } else {
        this.replace(targetBlock);
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy(animate) {
      this.destroy(animate);
      if (this.thread && this.thread.updateValueBlock) {
        this.thread.updateValueBlock();
      }
      this.getCode().changeEvent.notify();
      return this;
    }
  }, {
    key: "doDestroyBelow",
    value: function doDestroyBelow(animate) {
      this.destroy(animate, true);
      this.getCode().changeEvent.notify();
      return this;
    }
  }, {
    key: "copy",
    value: function copy() {
      var thread = this.getThread();
      var cloned = [];
      if (thread instanceof Entry.Thread) {
        var index = thread.getBlocks().indexOf(this);
        var json = thread.toJSON(true, index);
        for (var i = 0; i < json.length; i++) {
          cloned.push(json[i]);
        }
      } else {
        cloned.push(this.toJSON(true));
      }
      var _this$view$getAbsolut = this.view.getAbsoluteCoordinate(),
        x = _this$view$getAbsolut.x,
        y = _this$view$getAbsolut.y;
      var block = cloned[0];
      block.x = x + 15;
      block.y = y + 15;
      block.id = Entry.Utils.generateId();
      return cloned;
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard() {
      Entry.clipboard = this.copy();
    }
  }, {
    key: "separate",
    value: function separate(count, index) {
      this.thread.separate(this, count, index);
      this._updatePos();
      this.getCode().changeEvent.notify();
    }
  }, {
    key: "insert",
    value: function insert(targetBlock) {
      var blocks = this.thread.cut(this);
      if (targetBlock instanceof Entry.Thread) {
        targetBlock.insertByBlock(null, blocks);
      } else {
        targetBlock.insertAfter(blocks);
      }
      this._updatePos();
      this.getCode().changeEvent.notify();
    }
  }, {
    key: "replace",
    value: function replace(targetBlock) {
      if (!targetBlock) {
        console.error('replace error: target not exist');
        return;
      }
      this.thread.cut(this);
      targetBlock.getThread().replace(this);
      this.getCode().changeEvent.notify();
    }
  }, {
    key: "getPrevBlock",
    value: function getPrevBlock() {
      return this.thread.getPrevBlock(this);
    }
  }, {
    key: "getNextBlock",
    value: function getNextBlock() {
      return this.thread.getNextBlock(this) || null;
    }
  }, {
    key: "getFirstBlock",
    value: function getFirstBlock() {
      return this.thread.getFirstBlock();
    }
  }, {
    key: "getLastBlock",
    value: function getLastBlock() {
      return this.thread.getLastBlock();
    }
  }, {
    key: "getPrevOutputBlock",
    value: function getPrevOutputBlock() {
      var thread = this.thread;
      if (thread instanceof Entry.FieldOutput) {
        return thread._block;
      }
      return null;
    }
  }, {
    key: "getOutputBlock",
    value: function getOutputBlock() {
      var params = this._schema.params;
      for (var i = 0; params && i < params.length; i++) {
        var paramDef = params[i];
        if (paramDef.type === 'Output') {
          return this.params[i];
        }
      }
      return null;
    }
  }, {
    key: "getTerminateOutputBlock",
    value: function getTerminateOutputBlock() {
      var block = this;
      while (true) {
        var outputBlock = block.getOutputBlock();
        if (!outputBlock) {
          return block;
        }
        block = outputBlock;
      }
    }
  }, {
    key: "getOutputBlockCount",
    value: function getOutputBlockCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var outputBlock = this.getOutputBlock();
      if (outputBlock) {
        return outputBlock.getOutputBlockCount(count + 1);
      } else {
        return count;
      }
    }
  }, {
    key: "getBlockType",
    value: function getBlockType() {
      if (!this.view) {
        return null;
      }
      var skeleton = Entry.skeleton[this._schema.skeleton];
      if (!skeleton.magnets) {
        return null;
      }
      var magnet = skeleton.magnets(this.view);
      if (magnet.next || magnet.previous) {
        return 'basic';
      } else if (magnet["boolean"] || magnet.string) {
        return 'field';
      } else if (magnet.output || magnet.param) {
        return 'output';
      } else {
        return null;
      }
    }
  }, {
    key: "indexOfStatements",
    value: function indexOfStatements(statement) {
      return this.statements.indexOf(statement);
    }
  }, {
    key: "pointer",
    value: function pointer() {
      var _pointer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.thread.pointer(_pointer, this);
    }
  }, {
    key: "targetPointer",
    value: function targetPointer() {
      var pointer = this.thread.pointer([], this);
      if (pointer.length === 4 && pointer[3] === 0) {
        pointer.pop();
      } else if (pointer[pointer.length - 2] > -1) {
        if (pointer[pointer.length - 1] === 0) {
          pointer.pop();
        } else {
          pointer[pointer.length - 1] = pointer[pointer.length - 1] - 1;
        }
      }
      return pointer;
    }
  }, {
    key: "getDataByPointer",
    value: function getDataByPointer(pointer) {
      pointer = pointer.concat();
      var data = this.params[pointer.shift()];
      if (pointer.length) {
        if (data.getDataByPointer) {
          return data.getDataByPointer(pointer);
        } else {
          return null;
        }
      } else {
        return data;
      }
    }
  }, {
    key: "getBlockList",
    value: function getBlockList(excludePrimitive, type) {
      var blocks = [];
      var currentType = type || this.type;
      if (!this._schema && !this.loadSchema()) {
        return blocks;
      }
      if (excludePrimitive && this._schema.isPrimitive) {
        return blocks;
      }
      currentType === this.type && blocks.push(this);
      return [].concat((0, _toConsumableArray2["default"])(this.params), (0, _toConsumableArray2["default"])(this.statements)).reduce(function (blocks, value) {
        var constructor = value && value.constructor;
        if (constructor !== Entry.Block && constructor !== Entry.Thread) {
          return blocks;
        }
        return blocks.concat(value.getBlockList(excludePrimitive, type));
      }, blocks);
    }
  }, {
    key: "stringify",
    value: function stringify(excludeData) {
      return JSON.stringify(this.toJSON(false, excludeData));
    }
  }, {
    key: "isInOrigin",
    value: function isInOrigin() {
      return this.x === 0 && this.y === 0;
    }
  }, {
    key: "isSameParamWith",
    value: function isSameParamWith(target) {
      if (target.type.substr(0, 8) === 'wildcard' || this.type.substr(0, 8) === 'wildcard') {
        return true;
      }
      var targetType = target.type;
      var thisType = this.type;
      if (targetType === 'number' && thisType === 'positive_number' || targetType === 'number' && thisType === 'negative_number' || targetType === 'angle' && thisType === 'text' || targetType === 'text' && thisType === 'angle') {} else if (targetType !== thisType) {
        return false;
      }
      for (var i = 0; i < this.params.length; i++) {
        var param = this.params[i];
        if (param instanceof Entry.Block) {
          if (!param.isSameParamWith(target.params[i])) {
            return false;
          }
        } else {
          var l = this.params[i];
          var r = target.params[i];
          //entry-js로 변경되며서 null로 오던 것이 undefined로 와서 맞춰 줌.
          if (l === undefined) l = null;
          l = typeof l === 'number' ? "".concat(l) : l;
          r = typeof r === 'number' ? "".concat(r) : r;
          if (l === 'positive') {
            return r > 0;
          } else if (l === 'negative') {
            return r < 0;
          } else if (l !== r) {
            return false;
          }
        }
      }
      return true;
    }
  }, {
    key: "paramsBackup",
    value: function paramsBackup() {
      //do not backup params for blockMenu block
      if (_.result(this.view, 'isInBlockMenu')) {
        return;
      }
      this._backupParams = this.params.slice();
    }
  }, {
    key: "destroyParamsBackup",
    value: function destroyParamsBackup() {
      this._backupParams = null;
    }
  }, {
    key: "getDom",
    value: function getDom() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (_.isEmpty(query)) {
        return this.view.svgGroup;
      }
      query = (0, _toConsumableArray2["default"])(query);
      var key = query.shift();
      if (key === 'magnet') {
        return this.view.getMagnet(query);
      }
    }
  }, {
    key: "getParam",
    value: function getParam(index) {
      return this.params[index];
    }
  }, {
    key: "isParamBlockType",
    value: function isParamBlockType() {
      return /^(basic_string_field|basic_boolean_field)$/.test(this._schema.skeleton);
    }
  }, {
    key: "getFuncId",
    value: function getFuncId() {
      var ret = /func_(.*)/.exec(this.type);
      if (!ret) {
        return;
      }
      return ret[1];
    }
  }, {
    key: "getRootBlock",
    value: function getRootBlock() {
      var block = this;
      while (block) {
        var thread = block.getThread();
        var parent = thread.parent;
        if (!parent) {
          //field block
          block = thread._block;
        } else if (parent instanceof Entry.Code) {
          //thread
          block = thread.getFirstBlock();
          break;
        } else if (parent instanceof Entry.Block) {
          //statement
          block = thread.parent;
        } else if (parent instanceof Entry.FieldBlock) {
          break;
        } else {
          block = undefined;
        }
      }
      return block;
    }
  }, {
    key: "connectComment",
    value: function connectComment(comment) {
      this._comment = comment;
    }
  }, {
    key: "disconnectComment",
    value: function disconnectComment() {
      delete this._comment;
    }
  }, {
    key: "getCommentValue",
    value: function getCommentValue() {
      return this._comment && this._comment.value;
    }
  }]);
}();
Entry.Block.MAGNET_RANGE = 10;
Entry.Block.MAGNET_OFFSET = 0.4;
Entry.Block.DELETABLE_TRUE = 1;
Entry.Block.DELETABLE_FALSE = 2;
Entry.Block.DELETABLE_FALSE_LIGHTEN = 3;